import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from 'react-toastify';
import { UserProfileInline } from "../components/UserProfileInline";
import moment from "moment";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import sanitizeHtml from 'sanitize-html';

export const CommentListItemView = ({ comment, type, root, readOnly = false, children, onReplyForm = f => f, onModifyForm = f => f }) => {
    const queryClient = useQueryClient();
    const auth = useSelector((state) => state.auth);

    //-------------- 삭제
    const commentDeleteMutate = useMutation({
        mutationFn: () => Api.get(`/api/comment/${comment.id}/delete`),
        onSuccess: (res) => {
            queryClient.setQueryData(['comment/list', type, root.id], (oldData) => {
                const newList = oldData.data.list.map(cmt => {
                    if (cmt.id === comment.id) {
                        cmt.deleteYn = "Y";
                        cmt.content = "삭제된 댓글입니다.";
                        cmt.deletedAt = moment();
                    }
                    return cmt
                });
                return { ...oldData, data: { ...oldData.data, list: newList } };
            });
        },
        onError: (err) => {
            toast.error(createFetchErrorMessage(err).message);
        }
    });

    const onDeleteComment = useCallback((comment) => {
        if (!auth.authenticated) return;
        if (!auth.isSystemAdmin && comment.userId !== auth.id) {
            alert('삭제 권한이 없습니다.');
            return;
        }

        if (!window.confirm("삭제하시겠습니까?")) return;
        commentDeleteMutate.mutate();
    }, [auth, commentDeleteMutate]);

    // null이 올일이 없을텐데? 
    if (comment === null) return null;
    let contentHtml = comment.content.replace(/\n/gi, "<br />");
    if (comment.commentUserName || comment.commentName) {
        contentHtml = `<span class="toUser">@${comment.commentUserName || comment.commentName}</span>` + sanitizeHtml(contentHtml);
    }

    return (
        <div className={`reply reply_depth reply_depth_${comment.gdepth === 0 ? 0 : (comment.gdepth % 19) + 1} ${comment.gdepth === 0 ? "reply_box" : ""}  ${comment.deleteYn === "Y" ? "delete" : ""} ${comment.gcount > 0 ? "group" : ""} ${comment.id} }`} >
            <UserProfileInline className="writer_info"
                id={comment?.userId} name={comment.userName || comment.name} image={comment.userImage}
                type={comment.userType} school={comment.schoolName}
                createdAt={moment(comment.createdAt).format("LLL")}
            >
                {comment.creater === 'Y' && <span className="badge creater">작성자</span>}
            </UserProfileInline>

            <div className="text">
                <div className="depth_icon">
                    <p className="icon_number">{comment.gdepth}</p>
                    <div className="icon"></div>
                </div>
                <span className="content" dangerouslySetInnerHTML={{ __html: contentHtml }}></span>
                {comment.deleteYn === "Y" && (
                    <span className="delete_time">
                        &nbsp; (삭제시간: {moment(comment.deletedAt).format('LLL')})
                    </span>
                )}
                <div className="btn_wrap">
                    {comment.deleteYn === "N" && !readOnly && auth.authenticated && (
                        <button type="button" className="btn _xsm write_btn" onClick={onReplyForm}>
                            답글쓰기
                        </button>
                    )}
                    {comment.deleteYn === "N" && !readOnly && auth.authenticated && comment.userId === auth.id && (
                        <button className="btn _xsm _blue btn_edit" onClick={onModifyForm}>
                            수정
                        </button>
                    )}
                    {comment.deleteYn === "N" && auth.authenticated && (auth.isSystemAdmin || comment.userId === auth.id) && (
                        <button
                            className="btn _xsm _red btn_delete"
                            onClick={() => onDeleteComment(comment)}
                        >
                            삭제
                        </button>
                    )}
                </div>
            </div>
            {children}
        </div>
    )
};